import styled from "styled-components";
export const LoaderContainer = styled.div`
  display: grid;
  place-content: center;
  width: 100%;
  height: 100%;
  min-height: 45vh;
`;
